export default __webpack_public_path__ + "static/media/breakfast_toast.4132b13a.jpg";